// extracted by mini-css-extract-plugin
export var photo = "InfoWithLeftBkgdImg-module--photo--ZZJcO";
export var specialSection = "InfoWithLeftBkgdImg-module--specialSection--dJU0V";